export const updateAuxiliaryWASuccess = {
	header: 'Work Assignment was deleted successfully!',
	label: 'Your changes have been updated.',
	appearance: 'success',
};
